module.exports = __webpack_public_path__ + "img/output_4.72b7f746.png";